import { useMutation, useQuery, useQueryClient } from "react-query";
import { OrganizationKeyName } from "../../../model/Organization";

import { paymentProviderConfigurationsHttp } from "./payment-provider-configurations-http";
import { PaymentProviderConfiguration } from "../models/payment-provider-configuration";

export const paymentProviderConfigurationsCacheKeys = {
  paymentProviderConfigurations: "paymentProviderConfigurations",
  paymentProviderConfiguration: "paymentProviderConfiguration",
  paymentProviders: "paymentProviders",
};

export const useListPaymentProviderConfigurations = (
  organizationKeyName: OrganizationKeyName
) => {
  return useQuery<PaymentProviderConfiguration[], any>(
    [
      paymentProviderConfigurationsCacheKeys.paymentProviderConfigurations,
      organizationKeyName,
    ],
    () =>
      paymentProviderConfigurationsHttp.getPaymentProviderConfigurations(
        organizationKeyName
      ),
    { refetchOnWindowFocus: false }
  );
};

export const useGetPaymentProviderConfiguration = (
  organizationKeyName: OrganizationKeyName,
  id?: string
) => {
  return useQuery<PaymentProviderConfiguration | undefined, any>(
    [paymentProviderConfigurationsCacheKeys.paymentProviderConfiguration, id],
    () =>
      paymentProviderConfigurationsHttp.getPaymentProviderConfiguration(
        organizationKeyName,
        id
      ),
    { refetchOnWindowFocus: false, enabled: !!id }
  );
};

export const useGetPaymentProviders = (
  organizationKeyName: OrganizationKeyName
) => {
  return useQuery(
    [paymentProviderConfigurationsCacheKeys.paymentProviders],
    () =>
      paymentProviderConfigurationsHttp.getPaymentProviders(
        organizationKeyName
      ),
    { refetchOnWindowFocus: false }
  );
};

export const useUpdatePaymentProviderConfiguration = (id?: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    paymentProviderConfigurationsHttp.updatePaymentProviderConfiguration,
    {
      onSuccess: async () => {
        await queryClient.refetchQueries(
          paymentProviderConfigurationsCacheKeys.paymentProviderConfigurations
        );
        if (id) {
          await queryClient.refetchQueries([
            paymentProviderConfigurationsCacheKeys.paymentProviderConfiguration,
            id,
          ]);
        }
      },
    }
  );
};

export const useCreatePaymentProviderConfiguration = () => {
  const queryClient = useQueryClient();

  return useMutation(
    paymentProviderConfigurationsHttp.createPaymentProviderConfiguration,
    {
      onSuccess: async () => {
        await queryClient.refetchQueries(
          paymentProviderConfigurationsCacheKeys.paymentProviderConfigurations
        );
      },
    }
  );
};

export const useDeletePaymentProviderConfiguration = () => {
  const queryClient = useQueryClient();

  return useMutation(
    paymentProviderConfigurationsHttp.deletePaymentProviderConfiguration,
    {
      onSuccess: async () => {
        await queryClient.refetchQueries(
          paymentProviderConfigurationsCacheKeys.paymentProviderConfigurations
        );
      },
    }
  );
};
